import { FC } from 'react';
import { formatDate } from 'Shared/Utils';
import { Avatar } from './Avatar/Avatar';
import { capitalizeFirstLetter } from 'Shared/Utils';
import styles from './Contact.module.scss';

type ContactParams = {
  name: string;
  isActive: boolean;
  clickHandler: () => void;
  isGroup?: boolean;
  message?: string;
  timestamp?: string | number;
  avatarURL?: string | null;
  userRole?: string;
};

export const Contact: FC<ContactParams> = ({
  name,
  isActive,
  clickHandler: handleClick,
  isGroup = false,
  message = '',
  timestamp = '',
  avatarURL = '',
  userRole = '',
}) => {
  return (
    <div
      className={`${styles.contact} ${isActive && styles.contact_active}`}
      onClick={handleClick}
    >
      {isGroup && <Avatar avatarURL={avatarURL} />}
      <div
        className={`${styles.contact__main} ${isGroup && styles.contact__main_group}`}
      >
        <span className={styles.contact__main__name} title={name}>
          {name}
        </span>
        <span
          className={styles.contact__main__lastMessage}
          title={timestamp ? message : ''}
        >
          {timestamp && message}
        </span>
      </div>
      <div className={styles.contact__meta}>
        {timestamp && (
          <span className={styles.contact__meta__lastMessageDate}>
            {formatDate({
              date: timestamp,
              outputFormat: 'date',
              splitDateByDots: true,
            })}
          </span>
        )}
        {isGroup === false && (
          <span className={styles.contact__meta__role}>
            {capitalizeFirstLetter(userRole)}
          </span>
        )}
      </div>
    </div>
  );
};
